import axios from 'axios'

// Base URL'i environment variable'dan al
const baseURL = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000'

// Auth helper functions
const getAuthFromCookie = () => {
  const cookies = document.cookie.split(';')
  const authCookie = cookies.find(cookie => cookie.trim().startsWith('auth='))
  if (authCookie) {
    return authCookie.split('=')[1]
  }
  return null
}

const setAuthCookie = (username, password) => {
  const credentials = btoa(`${username}:${password}`)
  const expiryDate = new Date()
  expiryDate.setDate(expiryDate.getDate() + 180) // 180 gün
  document.cookie = `auth=${credentials}; expires=${expiryDate.toUTCString()}; path=/`
  return credentials
}

const clearAuthCookie = () => {
  document.cookie = 'auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
}

// Axios instance oluştur
const apiClient = axios.create({
  baseURL: baseURL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  }
})

// Request interceptor - auth header ekle
apiClient.interceptors.request.use(
  (config) => {
    // console.log(`API Request: ${config.method?.toUpperCase()} ${config.url}`)

    // Cookie'den auth bilgisini al ve header'a ekle
    const authCredentials = getAuthFromCookie()
    if (authCredentials) {
      config.headers.Authorization = `Basic ${authCredentials}`
    }

    return config
  },
  (error) => {
    console.error('Request Error:', error)
    return Promise.reject(error)
  }
)

// Response interceptor - 401 hatalarını yakala
apiClient.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    console.error('API Error:', error.response?.data || error.message)

    // 401 hatası durumunda login sayfasına yönlendir
    if (error.response?.status === 401) {
      clearAuthCookie()
      // Vue router'a erişim için window.location kullanıyoruz
      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
    } else if (error.response?.status === 404) {
      console.error('API endpoint not found')
    } else if (error.response?.status >= 500) {
      console.error('Server error occurred')
    } else if (error.code === 'ECONNABORTED') {
      console.error('Request timeout')
    }

    return Promise.reject(error)
  }
)

// Auth fonksiyonlarını export et
export { setAuthCookie, clearAuthCookie, getAuthFromCookie }
export default apiClient
